export interface ComicChapter {
  id: number;
  title: string;
  chapterNumber: number;
  updatedAt: string;
  viewCount: number;
}

export interface ComicData {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  totalViews: number;
  totalChapters: number;
  tags: string[];
  updatedAt: string;
  createdAt: string;
  featured: boolean;
  isHot: boolean;
  isNew: boolean;
  chapters: ComicChapter[];
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '搞笑', slug: 'comedy' },
  { name: '悬疑', slug: 'mystery' },
  { name: '恐怖', slug: 'horror' },
  { name: '耽美', slug: 'bl' },
  { name: '剧情', slug: 'drama' },
  { name: '日常', slug: 'slice-of-life' },
  { name: '校园', slug: 'school' },
  { name: '历史', slug: 'historical' },
];

export const comics: ComicData[] = [
  {
    id: 1,
    title: '秘密花园',
    author: '金秀妍',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20cover%20illustration%20with%20two%20characters%20in%20a%20romantic%20garden%20setting%2C%20soft%20pastel%20colors%2C%20cherry%20blossoms%2C%20elegant%20anime%20art%20style%2C%20clean%20composition%20with%20warm%20lighting&width=600&height=800&seq=hanman-comic-cover-01&orientation=portrait',
    description: '一段发生在首尔江南区的浪漫爱情故事。女主角林智恩是一名普通的上班族，意外邂逅了公司新来的神秘总监。两人在职场与生活中经历了一系列甜蜜又曲折的故事，最终揭开彼此内心深处隐藏的秘密。作品以细腻的画风和真实的情感描写著称，自连载以来广受好评。',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.8,
    totalViews: 1285000,
    totalChapters: 67,
    tags: ['恋爱', '职场', '甜蜜', '都市'],
    updatedAt: '2026-08-03',
    createdAt: '2025-03-15',
    featured: true,
    isHot: true,
    isNew: false,
    chapters: Array.from({ length: 67 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 8))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 50000) + 10000,
    })),
  },
  {
    id: 2,
    title: '暗夜追踪者',
    author: '李正浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20manhwa%20cover%20with%20a%20mysterious%20detective%20character%20in%20a%20rainy%20Seoul%20night%20street%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20action%20pose%2C%20detailed%20anime%20art%20style%20with%20neon%20reflections&width=600&height=800&seq=hanman-comic-cover-02&orientation=portrait',
    description: '首尔夜晚的街头，一名神秘侦探追踪连环案件。朴振宇曾是警界的传奇人物，因一次意外被迫离职，成为私家侦探。在调查一系列离奇案件的过程中，他逐渐发现这些案件背后隐藏着一个惊天阴谋。紧张刺激的剧情、精湛的画功，让读者欲罢不能。',
    category: '悬疑',
    categorySlug: 'mystery',
    status: '连载中',
    rating: 4.7,
    totalViews: 985000,
    totalChapters: 54,
    tags: ['悬疑', '侦探', '犯罪', '都市'],
    updatedAt: '2026-08-02',
    createdAt: '2025-06-20',
    featured: true,
    isHot: true,
    isNew: false,
    chapters: Array.from({ length: 54 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 7))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 45000) + 8000,
    })),
  },
  {
    id: 3,
    title: '异世界美食之旅',
    author: '朴恩惠',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20showing%20a%20cheerful%20character%20cooking%20in%20a%20fantasy%20world%20with%20magical%20ingredients%2C%20warm%20color%20palette%2C%20delicious%20food%20illustrations%2C%20whimsical%20anime%20style%20with%20sparkling%20effects&width=600&height=800&seq=hanman-comic-cover-03&orientation=portrait',
    description: '平凡的女大学生金多美穿越到了充满魔法与奇幻生物的异世界。在这个世界里，她凭借自己精湛的厨艺，用各种神奇的食材烹饪出令人垂涎的美食，不仅赢得了异世界居民的心，更揭开了一个关于美食与魔法的古老传说。暖心的故事配上精美的美食画面，让人食指大动。',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.6,
    totalViews: 856000,
    totalChapters: 48,
    tags: ['奇幻', '美食', '穿越', '冒险'],
    updatedAt: '2026-08-03',
    createdAt: '2025-08-10',
    featured: true,
    isHot: false,
    isNew: true,
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 6))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 40000) + 6000,
    })),
  },
  {
    id: 4,
    title: '校园狂想曲',
    author: '崔敏俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20lively%20Korean%20manhwa%20school%20comedy%20cover%20with%20multiple%20characters%20in%20school%20uniforms%20having%20fun%2C%20bright%20colors%2C%20energetic%20atmosphere%2C%20expressive%20anime%20art%20style%20with%20exaggerated%20reactions&width=600&height=800&seq=hanman-comic-cover-04&orientation=portrait',
    description: '在一所普通的高中里，五个性格迥异的学生组成了一个奇特的社团。有学霸、体育健将、艺术天才、宅男和天然呆少女，他们在校园里上演了一幕幕令人捧腹的搞笑日常。这部漫画以轻松幽默的风格，展现了青春的美好与疯狂，是缓解压力的最佳选择。',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.5,
    totalViews: 720000,
    totalChapters: 82,
    tags: ['搞笑', '校园', '青春', '日常'],
    updatedAt: '2026-08-01',
    createdAt: '2025-01-05',
    featured: false,
    isHot: true,
    isNew: false,
    chapters: Array.from({ length: 82 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 10))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 35000) + 5000,
    })),
  },
  {
    id: 5,
    title: '剑与魔法纪元',
    author: '韩载锡',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20fantasy%20cover%20with%20a%20warrior%20holding%20a%20glowing%20sword%20in%20an%20epic%20medieval%20fantasy%20landscape%2C%20dramatic%20composition%2C%20dynamic%20action%20pose%2C%20detailed%20armor%20and%20magic%20effects&width=600&height=800&seq=hanman-comic-cover-05&orientation=portrait',
    description: '在一个被黑暗势力笼罩的幻想大陆上，年轻的剑士李贤宇踏上了拯救世界的征途。他需要收集传说中的七把圣剑，击败邪恶的魔王。在这场波澜壮阔的冒险中，他结识了来自不同种族的伙伴，共同面对重重考验。宏大的世界观设定和精彩的战斗场面，让这部作品成为动作奇幻迷的不二之选。',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.7,
    totalViews: 1120000,
    totalChapters: 95,
    tags: ['动作', '奇幻', '冒险', '战斗'],
    updatedAt: '2026-08-04',
    createdAt: '2024-10-20',
    featured: false,
    isHot: true,
    isNew: false,
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 12))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 55000) + 12000,
    })),
  },
  {
    id: 6,
    title: '深渊之眼',
    author: '尹智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20manhwa%20cover%20with%20an%20eerie%20eye%20motif%20and%20dark%20shadowy%20figures%2C%20creepy%20atmosphere%2C%20muted%20dark%20color%20palette%2C%20psychological%20horror%20theme%2C%20disturbing%20yet%20beautiful%20anime%20art%20style&width=600&height=800&seq=hanman-comic-cover-06&orientation=portrait',
    description: '少女韩素利拥有一双能看见鬼魂的眼睛。自从搬到一栋古老的公寓后，她开始被各种恐怖的灵异现象困扰。随着调查的深入，她发现这栋建筑隐藏着一个数十年前的惨案真相。每一话都充满了令人毛骨悚然的氛围和意想不到的转折，是恐怖漫画爱好者的必读之作。',
    category: '恐怖',
    categorySlug: 'horror',
    status: '已完结',
    rating: 4.4,
    totalViews: 645000,
    totalChapters: 36,
    tags: ['恐怖', '灵异', '悬疑', '心理'],
    updatedAt: '2026-07-15',
    createdAt: '2025-04-10',
    featured: false,
    isHot: false,
    isNew: false,
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(7, Math.ceil((i + 1) / 5))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 30000) + 4000,
    })),
  },
  {
    id: 7,
    title: '星光之恋',
    author: '张美兰',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20BL%20manhwa%20cover%20with%20two%20handsome%20male%20characters%20under%20a%20starry%20night%20sky%2C%20gentle%20atmosphere%2C%20soft%20colors%2C%20emotional%20connection%2C%20beautiful%20detailed%20anime%20art%20style&width=600&height=800&seq=hanman-comic-cover-07&orientation=portrait',
    description: '人气偶像组合的两位成员，在聚光灯背后展开了一段不为人知的感情。台前的光环和幕后的真心，经纪公司的压力和外界的眼光，他们能否守护这份来之不易的爱情？作品以细腻的情感刻画和唯美的画面风格，描绘了一段跨越偏见与阻碍的真挚情感。',
    category: '耽美',
    categorySlug: 'bl',
    status: '连载中',
    rating: 4.9,
    totalViews: 1560000,
    totalChapters: 72,
    tags: ['耽美', '娱乐圈', '恋爱', '现代'],
    updatedAt: '2026-08-03',
    createdAt: '2025-02-14',
    featured: true,
    isHot: true,
    isNew: false,
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 9))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 60000) + 15000,
    })),
  },
  {
    id: 8,
    title: '王朝风云',
    author: '权泰宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20manhwa%20cover%20with%20a%20noble%20character%20in%20traditional%20Korean%20hanbok%20in%20a%20palace%20setting%2C%20rich%20colors%2C%20elegant%20composition%2C%20dramatic%20historical%20atmosphere%2C%20detailed%20character%20design&width=600&height=800&seq=hanman-comic-cover-08&orientation=portrait',
    description: '朝鲜王朝时期，一位出身卑微的少年凭借过人的才智和勇气，在波谲云诡的宫廷斗争中一步步走向权力巅峰。历史与虚构交织，阴谋与忠诚较量，爱情与野心拉扯，这部历史题材巨作以其考究的时代细节和扣人心弦的剧情，赢得了无数读者的青睐。',
    category: '历史',
    categorySlug: 'historical',
    status: '连载中',
    rating: 4.6,
    totalViews: 890000,
    totalChapters: 60,
    tags: ['历史', '宫廷', '权谋', '古风'],
    updatedAt: '2026-08-02',
    createdAt: '2025-05-18',
    featured: false,
    isHot: false,
    isNew: true,
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 8))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 42000) + 7000,
    })),
  },
  {
    id: 9,
    title: '日常小确幸',
    author: '宋雅琳',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20manhwa%20slice%20of%20life%20cover%20with%20a%20young%20woman%20enjoying%20coffee%20at%20a%20cozy%20cafe%2C%20warm%20autumn%20colors%2C%20relaxing%20vibe%2C%20simple%20and%20clean%20anime%20art%20style&width=600&height=800&seq=hanman-comic-cover-09&orientation=portrait',
    description: '自由插画师郑夏恩的日常生活记录。没有惊天动地的冒险，没有扣人心弦的悬疑，只有平凡的日常中那些温暖人心的小确幸。一杯咖啡、一只流浪猫、一场意外的重逢……这些看似微不足道的瞬间，却构成了生活最真实的美好。适合在疲惫时翻阅的治愈系作品。',
    category: '日常',
    categorySlug: 'slice-of-life',
    status: '已完结',
    rating: 4.5,
    totalViews: 580000,
    totalChapters: 30,
    tags: ['日常', '治愈', '温暖', '生活'],
    updatedAt: '2026-06-20',
    createdAt: '2025-09-01',
    featured: false,
    isHot: false,
    isNew: false,
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(6, Math.ceil((i + 1) / 4))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 25000) + 3000,
    })),
  },
  {
    id: 10,
    title: '命运交叉点',
    author: '郑道贤',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20manhwa%20cover%20with%20multiple%20characters%20showing%20complex%20emotions%2C%20intertwined%20storylines%2C%20urban%20Seoul%20backdrop%2C%20mature%20atmosphere%2C%20realistic%20anime%20art%20style%20with%20emotional%20depth&width=600&height=800&seq=hanman-comic-cover-10&orientation=portrait',
    description: '四个在不同人生阶段做出不同选择的人，他们的命运如何交织在一起？这是一部探讨人生选择与命运的作品。每个角色都面临着人生的重要抉择——事业、爱情、家庭，每一个决定都可能改变一生的轨迹。深刻的人性洞察和真实的情感表达，让读者在故事中看到自己的影子。',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 4.8,
    totalViews: 1030000,
    totalChapters: 45,
    tags: ['剧情', '人生', '都市', '感动'],
    updatedAt: '2026-08-04',
    createdAt: '2025-11-08',
    featured: false,
    isHot: false,
    isNew: true,
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 6))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 48000) + 9000,
    })),
  },
  {
    id: 11,
    title: '青涩时光',
    author: '刘瑞元',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20manhwa%20school%20romance%20cover%20with%20two%20teenagers%20shyly%20interacting%20near%20school%20lockers%2C%20pastel%20pink%20and%20mint%20colors%2C%20spring%20cherry%20blossom%20atmosphere%2C%20gentle%20anime%20art%20style&width=600&height=800&seq=hanman-comic-cover-11&orientation=portrait',
    description: '高中一年级的春天，性格内向的安秀敏遇见了阳光开朗的转学生金泰亨。从最初的陌生到逐渐熟悉，从懵懂的好感到确认彼此的心意，一段青涩而美好的校园初恋就此展开。纯真的感情、细腻的心理描写、唯美的画风，让人仿佛回到了那段最美好的青春岁月。',
    category: '校园',
    categorySlug: 'school',
    status: '连载中',
    rating: 4.6,
    totalViews: 760000,
    totalChapters: 40,
    tags: ['校园', '恋爱', '青春', '初恋'],
    updatedAt: '2026-08-01',
    createdAt: '2026-01-20',
    featured: false,
    isHot: false,
    isNew: true,
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 5))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 38000) + 5000,
    })),
  },
  {
    id: 12,
    title: '魔法学院特优班',
    author: '姜秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20school%20cover%20with%20students%20in%20magical%20robes%20at%20a%20grand%20magic%20academy%2C%20floating%20spells%20and%20mystical%20creatures%2C%20vibrant%20colorful%20magic%20effects%2C%20adventure%20anime%20art%20style&width=600&height=800&seq=hanman-comic-cover-12&orientation=portrait',
    description: '在隐藏于现代都市中的魔法学院里，一群天赋异禀的年轻魔法师正在接受最严格的训练。主角赵恩星是学院有史以来最年轻的入学者，却拥有着连自己都不知道的惊人潜力。友情、竞争、成长，以及一个威胁整个魔法界的阴谋，共同编织成了这部精彩的奇幻校园故事。',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.7,
    totalViews: 1320000,
    totalChapters: 88,
    tags: ['奇幻', '校园', '魔法', '成长'],
    updatedAt: '2026-08-04',
    createdAt: '2025-07-01',
    featured: true,
    isHot: true,
    isNew: false,
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updatedAt: `2026-${String(Math.min(8, Math.ceil((i + 1) / 11))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 58000) + 14000,
    })),
  },
];

export const featuredComics = comics.filter(c => c.featured);
export const hotComics = comics.filter(c => c.isHot);
export const newComics = comics.filter(c => c.isNew);

export const reviews = [
  { id: 1, name: '小草莓', rating: 5, content: '韩漫网真的太棒了！画质清晰，更新速度也很快。我最喜欢在这里看《秘密花园》，每次更新都第一时间来看。界面也很清爽，没有乱七八糟的广告。', date: '2026-07-28' },
  { id: 2, name: '夜空中最亮的星', rating: 5, content: '找了很久才找到这么全的韩漫网站，分类很清晰，想看什么类型的一下就能找到。下拉式阅读体验也很流畅，比翻页的舒服多了，强烈推荐！', date: '2026-07-25' },
  { id: 3, name: '漫画迷小刘', rating: 4, content: '作为一个看了十年漫画的老读者，这个网站的漫画资源真的很丰富。从热门作品到小众佳作都有收录，而且还在不断更新。希望能一直保持下去！', date: '2026-07-20' },
  { id: 4, name: '春日暖阳', rating: 5, content: '朋友推荐的这个网站，一试就爱上了！每天通勤路上看几话，已经成了我的日常习惯。特别是收藏功能，追更非常方便。感谢韩漫网！', date: '2026-07-18' },
  { id: 5, name: '追风少年', rating: 5, content: '界面设计简洁大方，浏览体验一级棒。最重要的是漫画种类齐全，不管是恋爱、奇幻还是悬疑，都能找到自己喜欢的。已经推荐给身边所有爱看漫画的朋友了！', date: '2026-07-15' },
  { id: 6, name: '一杯奶茶', rating: 4, content: '看了好多韩漫网站，这个是用得最顺手的。阅读模式很舒服，图片加载也快。希望能增加更多的完結作品，追更等更新太煎熬啦哈哈。', date: '2026-07-12' },
];

export const faqs = [
  { question: '韩漫网上的漫画都是免费的吗？', answer: '是的，韩漫网上所有韩国漫画均提供免费在线阅读。我们致力于为广大漫画爱好者提供优质的阅读体验，无需付费即可畅读全部作品。' },
  { question: '如何使用下拉式阅读模式？', answer: '进入任意漫画的章节页面后，您可以直接向下滚动页面进行连续阅读。下拉式阅读模式让您无需点击翻页，即可流畅地浏览整话内容，获得沉浸式的阅读体验。' },
  { question: '韩漫网多久更新一次漫画？', answer: '我们的编辑团队会密切关注各漫画作品的更新动态，通常会在原作更新后的24小时内完成同步。热门作品的更新频率更高，您可以收藏喜爱的作品以便第一时间收到更新通知。' },
  { question: '如何在手机上阅读韩漫？', answer: '韩漫网采用响应式设计，完美适配手机、平板和电脑等各种设备。您只需使用手机浏览器访问我们的网站，即可享受流畅的移动端阅读体验，无需下载任何应用。' },
  { question: '网站上的漫画分类有哪些？', answer: '我们提供丰富的漫画分类，包括恋爱、奇幻、动作、搞笑、悬疑、恐怖、耽美、剧情、日常、校园、历史等多种类型。您可以通过分类导航快速找到感兴趣的作品。' },
  { question: '如何联系韩漫网的客服？', answer: '您可以通过关于我们页面上的联系表单发送消息，或直接发送邮件至我们的官方邮箱。我们的客服团队会在24小时内回复您的咨询和建议。' },
];